/* eslint-disable eqeqeq */
import React from 'react';
import { container } from 'tsyringe';
import { MenuJenisPelatihanPresenter } from '../../../../../../data/presenters/MenuJenisPelatihanPresenter';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MenuJenisPelatihan,
  SubMenuJenisPelatihan,
} from '../../../../../../entities/MenuJenisPelatihan';
import { JenisPelatihan } from '../../../../../../entities/JenisPelatihan';
import { JenisPelatihanPresenter } from '../../../../../../data/presenters/JenisPelatihanPresenter';
import { SettingPenilaian } from '../../../../../../entities/SettingPenilaian';
import { SettingPenilaianPresenter } from '../../../../../../data/presenters/SettingPenilaianPresenter';
import { PengajuanJenisPelatihan } from '../../../../../../entities/PengajuanJenisPelatihan';
import { PengajuanJenisPelatihanPresenter } from '../../../../../../data/presenters/PengajuanJenisPelatihanPresenter';

interface IState {
  isLoading: boolean;
  jumlahPage: number;
  jumlahPagePengajuan: number;
  page: number;
  pagePengajuan: number;
  keyword: string;
  keywordPengajuan: string;
  row: number;
  rowPengajuan: number;
  menuJenisPelatihan: MenuJenisPelatihan[];
  subMenuJenisPelatihan: SubMenuJenisPelatihan[];
  formId: number;
  formDialog: string;
  formMenuJenisPelatihan: string;
  formMenuJenisPelatihanId: number;
  formSubMenuJenisPelatihan: string;
  formSubMenuJenisPelatihanId: number;
  formKode: string;
  formNamaPelatihan: string;
  formKompetensi: string;
  formWaktuMulai: string;
  formWaktuSelesai: string;
  formJP: string;
  formKeterangan: string;
  formStatusPengajuan: string;
  formAlasan: string;
  typeMenu: string;
  formLoading: boolean;
  showDialog: boolean;
  showDialogDelete: boolean;
  totalJenisPelatihan: number;
  jenisPelatihan: JenisPelatihan[];
  pengajuanJenisPelatihan: PengajuanJenisPelatihan[];
  showDialogJenisPelatihan: boolean;
  showDialogPengajuanJenisPelatihan: boolean;
  showDialogDeleteJenisPelatihan: boolean;
  showDialogDeletePengajuanJenisPelatihan: boolean;
  subMenuJenisPelatihanIdActive: string;
  MenuJenisPelatihanIdActive: string;
  showModalSettingPenilaian: boolean;
  showDialogFormSettingPenilaian: boolean;
  showDialogDeletteSettingPenilaian: boolean;
  formJenisPelatihanId: number;
  formNilaiBawah: string;
  formNilaiAtas: string;
  formPredikat: string;
  selectJenisPelatihanId: string;
  settingPeniaian: SettingPenilaian[];
  metodePenambahan: number;
  filterStatusPengajuan: string;
  showDialogTolakPengajuan: boolean;
  showDialogFormTolakPengajuan: boolean;
  showDialogTerimaPengajuan: boolean;
  showDialogFormTerimaPengajuan: boolean;
}

interface InitialState {
  state: IState;
  getMenuJenisPelatihan: Function;
  getSubMenuJenisPelatihan: Function;
  setPage: Function;
  setPagePengajuan: Function;
  setPageRow: Function;
  setPageRowPengajuan: Function;
  setFormDialog: Function;
  setUpdate: Function;
  actionFormDialog: Function;
  setFormMenuJenisPelatihan: Function;
  setFormMenuJenisPelatihanId: Function;
  setFormSubMenuJenisPelatihan: Function;
  setFormSubMenuJenisPelatihanId: Function;
  setFormKode: Function;
  setFormNamaPelatihan: Function;
  setFormWaktuMulai: Function;
  setFormWaktuSelesai: Function;
  setFormKompetensi: Function;
  setFormJP: Function;
  setFormKeterangan: Function;
  setFormStatusPengajuan: Function;
  setFormAlasan: Function;
  setTypeMenu: Function;
  setShowDialog: Function;
  setShowDialogDelete: Function;
  deleteMenuJenisPelatihan: Function;
  getJenisPelatihan: Function;
  getPengajuanJenisPelatihan: Function;
  setShowDialogJenisPelatihan: Function;
  setShowDialogPengajuanJenisPelatihan: Function;
  setShowDialogDeleteJenisPelatihan: Function;
  setShowDialogDeletePengajuanJenisPelatihan: Function;
  searchJenisPelatihan: Function;
  searchPengajuanJenisPelatihan: Function;
  actionFormDialogJenisPelatihan: Function;
  actionFormDialogPengajuanJenisPelatihan: Function;
  setUpdateJenisPelatihan: Function;
  setUpdatePengajuanJenisPelatihan: Function;
  deleteJenisPelatihan: Function;
  deletePengajuanJenisPelatihan: Function;
  clearForm: Function;
  setActiveMenu: Function;
  setShowModalSettingPenilaian: Function;
  setShowDialogFormSettingPenilaian: Function;
  setShowDialogDeleteSettingPenilaian: Function;
  setFormJenisPelatihanId: Function;
  setFormNilaiBawah: Function;
  setFormNilaiAtas: Function;
  setFormPredikat: Function;
  getSettingPenilaian: Function;
  actionFormSettingPenilaian: Function;
  setUpdateSettingPenilaian: Function;
  deleteSettingPenilaian: Function;
  setFormId: Function;
  setMetodePenambahan: Function;
  setFilterStatusPengajuan: Function;
  setShowDialogTolakPengajuan: Function;
  setShowDialogFormTolakPengajuan: Function;
  setShowDialogTerimaPengajuan: Function;
  setShowDialogFormTerimaPengajuan: Function;
  actionDialogFormTolakPengajuan: Function;
  actionDialogFormTerimaPengajuan: Function;
}

const initialState = {
  state: {
    isLoading: true,
    jumlahPage: 0,
    jumlahPagePengajuan: 0,
    page: 1,
    pagePengajuan: 1,
    keyword: '',
    keywordPengajuan: '',
    row: 10,
    rowPengajuan: 10,
    menuJenisPelatihan: [],
    subMenuJenisPelatihan: [],
    formDialog: '',
    formId: 0,
    formMenuJenisPelatihan: '',
    formMenuJenisPelatihanId: 0,
    formSubMenuJenisPelatihan: '',
    formSubMenuJenisPelatihanId: 0,
    formKode: '',
    formNamaPelatihan: '',
    formKompetensi: '',
    formWaktuMulai: '',
    formWaktuSelesai: '',
    formJP: '',
    formKeterangan: '',
    formStatusPengajuan: '',
    formAlasan: '',
    typeMenu: 'menu',
    formLoading: false,
    showDialog: false,
    showDialogDelete: false,
    totalJenisPelatihan: 0,
    jenisPelatihan: [],
    pengajuanJenisPelatihan: [],
    showDialogJenisPelatihan: false,
    showDialogPengajuanJenisPelatihan: false,
    showDialogDeleteJenisPelatihan: false,
    showDialogDeletePengajuanJenisPelatihan: false,
    subMenuJenisPelatihanIdActive: '',
    MenuJenisPelatihanIdActive: '',
    showModalSettingPenilaian: false,
    showDialogFormSettingPenilaian: false,
    showDialogDeletteSettingPenilaian: false,
    formJenisPelatihanId: 0,
    formNilaiBawah: '',
    formNilaiAtas: '',
    formPredikat: '',
    selectJenisPelatihanId: '',
    settingPeniaian: [],
    metodePenambahan: 1,
    filterStatusPengajuan: '',
    showDialogTolakPengajuan: false,
    showDialogFormTolakPengajuan: false,
    showDialogTerimaPengajuan: false,
    showDialogFormTerimaPengajuan: false,
  },
  getMenuJenisPelatihan: () => {},
  getSubMenuJenisPelatihan: () => {},
  searchMenuJenisPelatihan: () => {},
  setPage: () => {},
  setPagePengajuan: () => {},
  setPageRow: () => {},
  setPageRowPengajuan: () => {},
  setFormDialog: () => {},
  setUpdate: () => {},
  actionFormDialog: () => {},
  setFormMenuJenisPelatihan: () => {},
  setFormMenuJenisPelatihanId: () => {},
  setFormSubMenuJenisPelatihan: () => {},
  setFormSubMenuJenisPelatihanId: () => {},
  setFormKode: () => {},
  setFormNamaPelatihan: () => {},
  setFormWaktuMulai: () => {},
  setFormWaktuSelesai: () => {},
  setFormKompetensi: () => {},
  setFormJP: () => {},
  setFormKeterangan: () => {},
  setFormStatusPengajuan: () => {},
  setFormAlasan: () => {},
  setTypeMenu: () => {},
  setShowDialog: () => {},
  deleteMenuJenisPelatihan: () => {},
  setShowDialogDelete: () => {},
  getJenisPelatihan: () => {},
  getPengajuanJenisPelatihan: () => {},
  setShowDialogJenisPelatihan: () => {},
  setShowDialogPengajuanJenisPelatihan: () => {},
  setShowDialogDeleteJenisPelatihan: () => {},
  setShowDialogDeletePengajuanJenisPelatihan: () => {},
  searchJenisPelatihan: () => {},
  searchPengajuanJenisPelatihan: () => {},
  actionFormDialogJenisPelatihan: () => {},
  actionFormDialogPengajuanJenisPelatihan: () => {},
  setUpdateJenisPelatihan: () => {},
  setUpdatePengajuanJenisPelatihan: () => {},
  deleteJenisPelatihan: () => {},
  deletePengajuanJenisPelatihan: () => {},
  clearForm: () => {},
  setActiveMenu: () => {},
  setShowModalSettingPenilaian: () => {},
  setShowDialogFormSettingPenilaian: () => {},
  setShowDialogDeleteSettingPenilaian: () => {},
  setFormJenisPelatihanId: () => {},
  setFormNilaiBawah: () => {},
  setFormNilaiAtas: () => {},
  setFormPredikat: () => {},
  getSettingPenilaian: () => {},
  actionFormSettingPenilaian: () => {},
  setUpdateSettingPenilaian: () => {},
  deleteSettingPenilaian: () => {},
  setFormId: () => {},
  setMetodePenambahan: () => {},
  setFilterStatusPengajuan: () => {},
  setShowDialogTolakPengajuan: () => {},
  setShowDialogFormTolakPengajuan: () => {},
  setShowDialogTerimaPengajuan: () => {},
  setShowDialogFormTerimaPengajuan: () => {},
  actionDialogFormTolakPengajuan: () => {},
  actionDialogFormTerimaPengajuan: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: MasterJenisPelatihanProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    jumlahPage: 0,
    jumlahPagePengajuan: 0,
    page: 1,
    pagePengajuan: 1,
    keyword: '',
    keywordPengajuan: '',
    row: 10,
    rowPengajuan: 10,
    menuJenisPelatihan: [],
    subMenuJenisPelatihan: [],
    formDialog: '',
    formId: 0,
    formMenuJenisPelatihan: '',
    formMenuJenisPelatihanId: 0,
    formSubMenuJenisPelatihan: '',
    formSubMenuJenisPelatihanId: 0,
    formKode: '',
    formNamaPelatihan: '',
    formKompetensi: '',
    formWaktuMulai: '',
    formWaktuSelesai: '',
    formJP: '',
    formKeterangan: '',
    formStatusPengajuan: '',
    formAlasan: '',
    typeMenu: 'menu',
    formLoading: false,
    showDialog: false,
    showDialogDelete: false,
    totalJenisPelatihan: 0,
    jenisPelatihan: [],
    pengajuanJenisPelatihan: [],
    showDialogJenisPelatihan: false,
    showDialogPengajuanJenisPelatihan: false,
    showDialogDeleteJenisPelatihan: false,
    showDialogDeletePengajuanJenisPelatihan: false,
    subMenuJenisPelatihanIdActive: '',
    MenuJenisPelatihanIdActive: '',
    showModalSettingPenilaian: false,
    showDialogFormSettingPenilaian: false,
    showDialogDeletteSettingPenilaian: false,
    formJenisPelatihanId: 0,
    formNilaiBawah: '',
    formNilaiAtas: '',
    formPredikat: '',
    selectJenisPelatihanId: '',
    settingPeniaian: [],
    metodePenambahan: 1,
    filterStatusPengajuan: '',
    showDialogTolakPengajuan: false,
    showDialogFormTolakPengajuan: false,
    showDialogTerimaPengajuan: false,
    showDialogFormTerimaPengajuan: false,
  });

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      page: value,
    }));
  };

  const setPagePengajuan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      pagePengajuan: value,
    }));
  };

  const setPageRow = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      row: value,
    }));
  };

  const setPageRowPengajuan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      rowPengajuan: value,
    }));
  };

  const setJumlahPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jumlahPage: value,
    }));
  };

  const setJumlahPagePengajuan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jumlahPagePengajuan: value,
    }));
  };

  const setMetodePenambahan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      metodePenambahan: value,
    }));
  };

  const setFilterStatusPengajuan = (value: string) => {
    setLoading(true);
    getPengajuanJenisPelatihan(
      state.pagePengajuan,
      state.keywordPengajuan,
      state.rowPengajuan,
      state.subMenuJenisPelatihanIdActive,
      value
    );
    setState((prevstate) => ({
      ...prevstate,
      filterStatusPengajuan: value,
    }));
  };

  const getMenuJenisPelatihan = async () => {
    setLoading(true);

    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );
      const getAllMenuJenisPelatihan =
        await menuJenisPelatihanPresenter.getAllMenuJenisPelatihan(
          1,
          1000000,
          ''
        );

      const data = getAllMenuJenisPelatihan;

      setState((prevstate) => ({
        ...prevstate,
        menuJenisPelatihan: data,
      }));

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getSubMenuJenisPelatihan = async () => {
    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );
      const getAllSubMenuJenisPelatihan =
        await menuJenisPelatihanPresenter.getAllSubMenuJenisPelatihan(
          1,
          1000000,
          ''
        );

      const data = getAllSubMenuJenisPelatihan;

      setState((prevstate) => ({
        ...prevstate,
        subMenuJenisPelatihan: data,
      }));

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const setFormDialog = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formDialog: value,
    }));
  };

  const setUpdate = (value: any, type: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value.id,
      typeMenu: type,
    }));

    if (type == 'menu') {
      setState((prevstate) => ({
        ...prevstate,
        formMenuJenisPelatihan: value.menu_jenis_pelatihan,
      }));
    } else {
      setState((prevstate) => ({
        ...prevstate,
        formMenuJenisPelatihanId: value.menu_jenis_pelatihan_id,
        formSubMenuJenisPelatihan: value.sub_menu_jenis_pelatihan,
      }));
    }

    setFormDialog('Ubah');
    setShowDialog(true);
  };

  const setFormLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      formLoading: value,
    }));
  };

  const actionFormDialog = async () => {
    setFormLoading(true);

    if (state.typeMenu == 'menu') {
      if (state.formMenuJenisPelatihan == '') {
        setFormLoading(false);
        toast.error('Data Belum Terisi Lengkap!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
        return;
      }
    }

    if (state.typeMenu != 'menu') {
      if (
        state.formMenuJenisPelatihanId == 0 ||
        state.formSubMenuJenisPelatihan == ''
      ) {
        toast.error('Data Belum Terisi Lengkap!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
        setFormLoading(false);
        return;
      }
    }

    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );
      if (state.formDialog == 'Tambah') {
        if (state.typeMenu == 'menu') {
          const action =
            await menuJenisPelatihanPresenter.storeMenuJenisPelatihan(
              state.formMenuJenisPelatihan
            );
          const data = action;

          setFormLoading(false);

          if (data.data.code == 200) {
            toast.success(data.data.message, {
              style: {
                boxShadow: '0px 1px 6px #019166',
              },
            });
            setShowDialog(false);
            getMenuJenisPelatihan();
            clearForm();
          } else {
            toast.error('Ada Kesalahan Saat Tambah Data!', {
              style: {
                boxShadow: '0px 1px 6px #F86E70',
              },
            });
          }
        } else {
          const action =
            await menuJenisPelatihanPresenter.storeSubMenuJenisPelatihan(
              state.formMenuJenisPelatihanId,
              state.formSubMenuJenisPelatihan
            );
          const data = action;

          setFormLoading(false);

          if (data.data.code == 200) {
            toast.success(data.data.message, {
              style: {
                boxShadow: '0px 1px 6px #019166',
              },
            });
            setShowDialog(false);
            getMenuJenisPelatihan();
            clearForm();
          } else {
            toast.error('Ada Kesalahan Saat Tambah Data!', {
              style: {
                boxShadow: '0px 1px 6px #F86E70',
              },
            });
          }
        }
      } else if (state.formDialog == 'Ubah') {
        if (state.typeMenu == 'menu') {
          const action =
            await menuJenisPelatihanPresenter.updateMenuJenisPelatihan(
              state.formId,
              state.formMenuJenisPelatihan
            );
          const data = action;

          setFormLoading(false);

          if (data.data.code == 200) {
            toast.success(data.data.message, {
              style: {
                boxShadow: '0px 1px 6px #019166',
              },
            });
            setShowDialog(false);
            getMenuJenisPelatihan();
            clearForm();
          } else {
            toast.error('Ada Kesalahan Saat Ubah Data!', {
              style: {
                boxShadow: '0px 1px 6px #F86E70',
              },
            });
          }
        } else {
          const action =
            await menuJenisPelatihanPresenter.updateSubMenuJenisPelatihan(
              state.formId,
              state.formMenuJenisPelatihanId,
              state.formSubMenuJenisPelatihan
            );
          const data = action;

          setFormLoading(false);

          if (data.data.code == 200) {
            toast.success(data.data.message, {
              style: {
                boxShadow: '0px 1px 6px #019166',
              },
            });
            setShowDialog(false);
            getMenuJenisPelatihan();
            clearForm();
          } else {
            toast.error('Ada Kesalahan Saat Ubah Data!');
          }
        }
      }
    } catch (error: any) {
      setFormLoading(false);

      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setFormMenuJenisPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formMenuJenisPelatihan: value,
    }));
  };

  const setFormMenuJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      formMenuJenisPelatihanId: value,
    }));
  };

  const setFormSubMenuJenisPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formSubMenuJenisPelatihan: value,
    }));
  };

  const setShowDialog = (value: boolean) => {
    if (state.formDialog == 'Tambah') {
      clearForm();
    }

    setState((prevstate) => ({
      ...prevstate,
      showDialog: value,
    }));
  };

  const clearForm = () => {
    setState((prevstate) => ({
      ...prevstate,
      formId: 0,
      formMenuJenisPelatihan: '',
      formMenuJenisPelatihanId: 0,
      formSubMenuJenisPelatihan: '',
      formSubMenuJenisPelatihanId: 0,
      formKode: '',
      formNamaPelatihan: '',
      formKompetensi: '',
      formWaktuMulai: '',
      formWaktuSelesai: '',
      formJP: '',
      formKeterangan: '',
      formNilaiBawah: '',
      formNilaiAtas: '',
      formPredikat: '',
      formAlasan: '',
    }));
  };

  const deleteMenuJenisPelatihan = async () => {
    setFormLoading(true);

    try {
      if (state.typeMenu == 'menu') {
        const menuJenisPelatihanPresenter = container.resolve(
          MenuJenisPelatihanPresenter
        );
        const action =
          await menuJenisPelatihanPresenter.deleteMenuJenisPelatihan(
            state.formId
          );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogDelete(false);
          getMenuJenisPelatihan();
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Hapus Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      } else {
        const menuJenisPelatihanPresenter = container.resolve(
          MenuJenisPelatihanPresenter
        );
        const action =
          await menuJenisPelatihanPresenter.deleteSubMenuJenisPelatihan(
            state.formId
          );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogDelete(false);
          getMenuJenisPelatihan();
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Hapus Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error menu jenis pelatihan:', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setShowDialogDelete = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDelete: value,
    }));
  };

  const setTypeMenu = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      typeMenu: value,
    }));
  };

  const getJenisPelatihan = async (
    pagee: number,
    keyword: string,
    row: number,
    sub_menu: string
  ) => {
    setLoading(true);

    try {
      const jenisPelatihanPresenter = container.resolve(
        JenisPelatihanPresenter
      );
      const getAllJenisPelatihan =
        await jenisPelatihanPresenter.getAllJenisPelatihan(
          pagee,
          row,
          keyword,
          sub_menu
        );

      const data = getAllJenisPelatihan;

      setJumlahPage(data[0].jumlahData / row);
      setPage(pagee);

      setState((prevstate) => ({
        ...prevstate,
        jenisPelatihan: data,
      }));

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getPengajuanJenisPelatihan = async (
    pagee: number,
    keyword: string,
    row: number,
    sub_menu: string,
    status_pengajuan: string
  ) => {
    setLoading(true);

    try {
      const pengajuanJenisPelatihanPresenter = container.resolve(
        PengajuanJenisPelatihanPresenter
      );
      const getAllPengajuanJenisPelatihan =
        await pengajuanJenisPelatihanPresenter.getAllPengajuanJenisPelatihan(
          pagee,
          row,
          keyword,
          sub_menu,
          status_pengajuan
        );

      const data = getAllPengajuanJenisPelatihan;

      setJumlahPagePengajuan(data[0].jumlahData / row);
      setPagePengajuan(pagee);

      setState((prevstate) => ({
        ...prevstate,
        pengajuanJenisPelatihan: data,
      }));

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const setShowDialogJenisPelatihan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogJenisPelatihan: value,
    }));
  };

  const setShowDialogPengajuanJenisPelatihan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogPengajuanJenisPelatihan: value,
    }));
  };

  const setShowDialogDeleteJenisPelatihan = (value: boolean, id: number) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDeleteJenisPelatihan: value,
      formId: id,
    }));
  };

  const setShowDialogDeletePengajuanJenisPelatihan = (
    value: boolean,
    id: number
  ) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDeletePengajuanJenisPelatihan: value,
      formId: id,
    }));
  };

  const searchJenisPelatihan = (
    value: string,
    subMenuJenisPelatihanIdActive: string
  ) => {
    setLoading(true);
    getJenisPelatihan(
      state.page,
      value,
      state.row,
      subMenuJenisPelatihanIdActive
    );
    setState((prevstate) => ({
      ...prevstate,
      keyword: value,
    }));
  };

  const searchPengajuanJenisPelatihan = (
    value: string,
    subMenuJenisPelatihanIdActive: string
  ) => {
    setLoading(true);
    getPengajuanJenisPelatihan(
      state.pagePengajuan,
      value,
      state.rowPengajuan,
      subMenuJenisPelatihanIdActive,
      state.filterStatusPengajuan
    );
    setState((prevstate) => ({
      ...prevstate,
      keywordPengajuan: value,
    }));
  };

  const setFormSubMenuJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      formSubMenuJenisPelatihanId: value,
    }));
  };

  const setFormKode = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formKode: value,
    }));
  };

  const setFormNamaPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formNamaPelatihan: value,
    }));
  };

  const setFormWaktuMulai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formWaktuMulai: value,
    }));
  };

  const setFormWaktuSelesai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formWaktuSelesai: value,
    }));
  };

  const setFormKompetensi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formKompetensi: value,
    }));
  };

  const setFormJP = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formJP: value,
    }));
  };

  const setFormKeterangan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formKeterangan: value,
    }));
  };

  const setFormStatusPengajuan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formKeterangan: value,
    }));
  };

  const setFormAlasan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formAlasan: value,
    }));
  };

  const actionFormDialogJenisPelatihan = async () => {
    setFormLoading(true);

    if (
      state.formSubMenuJenisPelatihanId == 0 ||
      state.formKode == '' ||
      state.formNamaPelatihan == '' ||
      state.formKompetensi == '' ||
      state.formJP == '' ||
      state.formKeterangan == '' ||
      state.formWaktuMulai == '' ||
      state.formWaktuSelesai == ''
    ) {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setFormLoading(false);
      return;
    }

    const dateWaktuMulai = new Date(state.formWaktuMulai);
    const dateWaktuSelesai = new Date(state.formWaktuSelesai);

    if (dateWaktuMulai > dateWaktuSelesai) {
      toast.error(
        'Tanggal Mulai tidak boleh lebih besar dari Tanggal Selesai.',
        {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        }
      );
      setFormLoading(false);
      return;
    }

    try {
      const jenisPelatihanPresenter = container.resolve(
        JenisPelatihanPresenter
      );
      if (state.formDialog == 'Tambah') {
        const dateWaktuMulai = new Date(state.formWaktuMulai);
        const formattedWaktuMulai = dateWaktuMulai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const dateWaktuSelesai = new Date(state.formWaktuSelesai);
        const formattedWaktuSelesai = dateWaktuSelesai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const action = await jenisPelatihanPresenter.storeJenisPelatihan(
          state.formSubMenuJenisPelatihanId,
          state.formKode,
          state.formNamaPelatihan,
          state.formKompetensi,
          state.formJP,
          state.formKeterangan,
          state.metodePenambahan,
          formattedWaktuMulai,
          formattedWaktuSelesai
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogJenisPelatihan(false);
          getJenisPelatihan(
            state.page,
            state.keyword,
            state.row,
            state.subMenuJenisPelatihanIdActive
          );
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Tambah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      } else if (state.formDialog == 'Ubah') {
        const dateWaktuMulai = new Date(state.formWaktuMulai);
        const formattedWaktuMulai = dateWaktuMulai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const dateWaktuSelesai = new Date(state.formWaktuSelesai);
        const formattedWaktuSelesai = dateWaktuSelesai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const action = await jenisPelatihanPresenter.updateJenisPelatihan(
          state.formId,
          state.formSubMenuJenisPelatihanId,
          state.formKode,
          state.formNamaPelatihan,
          state.formKompetensi,
          state.formJP,
          state.formKeterangan,
          state.metodePenambahan,
          formattedWaktuMulai,
          formattedWaktuSelesai
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogJenisPelatihan(false);
          getJenisPelatihan(
            state.page,
            state.keyword,
            state.row,
            state.subMenuJenisPelatihanIdActive
          );
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Ubah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error jenis pelatihan:', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const actionFormDialogPengajuanJenisPelatihan = async () => {
    setFormLoading(true);

    if (
      state.formSubMenuJenisPelatihanId == 0 ||
      state.formNamaPelatihan == '' ||
      state.formKompetensi == '' ||
      state.formWaktuMulai == '' ||
      state.formWaktuSelesai == '' ||
      state.formJP == '' ||
      state.formKeterangan == ''
    ) {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setFormLoading(false);
      return;
    }

    const dateWaktuMulai = new Date(state.formWaktuMulai);
    const dateWaktuSelesai = new Date(state.formWaktuSelesai);

    if (dateWaktuMulai > dateWaktuSelesai) {
      toast.error(
        'Tanggal Mulai tidak boleh lebih besar dari Tanggal Selesai.',
        {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        }
      );
      setFormLoading(false);
      return;
    }

    try {
      const pengajuanJenisPelatihanPresenter = container.resolve(
        PengajuanJenisPelatihanPresenter
      );
      if (state.formDialog == 'Request') {
        const dateWaktuMulai = new Date(state.formWaktuMulai);
        const formattedWaktuMulai = dateWaktuMulai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const dateWaktuSelesai = new Date(state.formWaktuSelesai);
        const formattedWaktuSelesai = dateWaktuSelesai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const action =
          await pengajuanJenisPelatihanPresenter.storePengajuanJenisPelatihan(
            state.formSubMenuJenisPelatihanId,
            state.formNamaPelatihan,
            formattedWaktuMulai,
            formattedWaktuSelesai,
            state.formKompetensi,
            state.formJP,
            state.formKeterangan
          );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogPengajuanJenisPelatihan(false);
          getPengajuanJenisPelatihan(
            state.pagePengajuan,
            state.keywordPengajuan,
            state.rowPengajuan,
            state.subMenuJenisPelatihanIdActive,
            state.filterStatusPengajuan
          );
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Tambah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      } else if (state.formDialog == 'Revisi') {
        const dateWaktuMulai = new Date(state.formWaktuMulai);
        const formattedWaktuMulai = dateWaktuMulai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const dateWaktuSelesai = new Date(state.formWaktuSelesai);
        const formattedWaktuSelesai = dateWaktuSelesai
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];

        const action =
          await pengajuanJenisPelatihanPresenter.updatePengajuanJenisPelatihan(
            state.formId,
            state.formSubMenuJenisPelatihanId,
            state.formNamaPelatihan,
            formattedWaktuMulai,
            formattedWaktuSelesai,
            state.formKompetensi,
            state.formJP,
            state.formKeterangan,
            'direvisi',
            '',
            ''
          );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogPengajuanJenisPelatihan(false);
          getPengajuanJenisPelatihan(
            state.pagePengajuan,
            state.keywordPengajuan,
            state.rowPengajuan,
            state.subMenuJenisPelatihanIdActive,
            state.filterStatusPengajuan
          );
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Ubah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error jenis pelatihan:', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setUpdateJenisPelatihan = (value: JenisPelatihan) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value.id,
      formSubMenuJenisPelatihanId: value.sub_menu_jenis_pelatihan_id,
      formKode: value.kode,
      formNamaPelatihan: value.nama_pelatihan,
      formKompetensi: value.kompetensi,
      formWaktuMulai: value.waktu_mulai,
      formWaktuSelesai: value.waktu_selesai,
      formJP: value.jp,
      formKeterangan: value.keterangan,
      metodePenambahan: value.metode_penambahan,
    }));

    setFormDialog('Ubah');
    setShowDialogJenisPelatihan(true);
  };

  const setUpdatePengajuanJenisPelatihan = (value: PengajuanJenisPelatihan) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value.id,
      formSubMenuJenisPelatihanId: value.sub_menu_jenis_pelatihan_id,
      formNamaPelatihan: value.nama_pelatihan,
      formWaktuMulai: value.waktu_mulai,
      formWaktuSelesai: value.waktu_selesai,
      formKompetensi: value.kompetensi,
      formJP: value.jp,
      formKeterangan: value.keterangan,
      formStatusPengajuan: value.status_pengajuan,
    }));

    setFormDialog('Revisi');
    setShowDialogPengajuanJenisPelatihan(true);
  };

  const deleteJenisPelatihan = async () => {
    setFormLoading(true);

    try {
      const jenisPelatihanPresenter = container.resolve(
        JenisPelatihanPresenter
      );
      const action = await jenisPelatihanPresenter.deleteJenisPelatihan(
        state.formId
      );
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success(data.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogDeleteJenisPelatihan(false, 0);
        getJenisPelatihan(
          state.page,
          state.keyword,
          state.row,
          state.subMenuJenisPelatihanIdActive
        );
        clearForm();
      } else {
        toast.error('Ada Kesalahan Saat Hapus Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error jenis pelatihan:', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const deletePengajuanJenisPelatihan = async () => {
    setFormLoading(true);

    try {
      const pengajuanJenisPelatihanPresenter = container.resolve(
        PengajuanJenisPelatihanPresenter
      );
      const action =
        await pengajuanJenisPelatihanPresenter.deletePengajuanJenisPelatihan(
          state.formId
        );
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success(data.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogDeletePengajuanJenisPelatihan(false, 0);
        getPengajuanJenisPelatihan(
          state.page,
          state.keyword,
          state.row,
          state.subMenuJenisPelatihanIdActive,
          state.filterStatusPengajuan
        );
        clearForm();
      } else {
        toast.error('Ada Kesalahan Saat Hapus Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error jenis pelatihan:', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setActiveMenu = (idMenu: string, idSubMenu: string) => {
    setState((prevstate) => ({
      ...prevstate,
      MenuJenisPelatihanIdActive: idMenu,
      subMenuJenisPelatihanIdActive: idSubMenu,
      jenisPelatihan: [],
    }));

    getJenisPelatihan(state.page, state.keyword, state.row, idSubMenu);
    getPengajuanJenisPelatihan(
      state.pagePengajuan,
      state.keywordPengajuan,
      state.rowPengajuan,
      idSubMenu,
      state.filterStatusPengajuan
    );
  };

  const setShowModalSettingPenilaian = (
    value: boolean,
    pelatihan_id: string
  ) => {
    setState((prevstate) => ({
      ...prevstate,
      showModalSettingPenilaian: value,
      settingPeniaian: [],
      selectJenisPelatihanId: pelatihan_id,
    }));

    getSettingPenilaian(pelatihan_id);
  };

  const setShowDialogFormSettingPenilaian = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogFormSettingPenilaian: value,
    }));

    if (value) {
      setState((prevstate) => ({
        ...prevstate,
        showModalSettingPenilaian: false,
      }));
    } else {
      setState((prevstate) => ({
        ...prevstate,
        showModalSettingPenilaian: true,
      }));
    }
  };

  const setShowDialogDeleteSettingPenilaian = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDeletteSettingPenilaian: value,
    }));

    if (value) {
      setState((prevstate) => ({
        ...prevstate,
        showModalSettingPenilaian: false,
      }));
    } else {
      setState((prevstate) => ({
        ...prevstate,
        showModalSettingPenilaian: true,
      }));
    }
  };

  const setFormJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      formJenisPelatihanId: value,
    }));
  };

  const setFormNilaiAtas = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formNilaiAtas: value,
    }));
  };

  const setFormNilaiBawah = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formNilaiBawah: value,
    }));
  };

  const setFormPredikat = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formPredikat: value,
    }));
  };

  const getSettingPenilaian = async (jenis_pelatihan_id: string) => {
    setLoading(true);

    try {
      const settingPenilaianPresenter = container.resolve(
        SettingPenilaianPresenter
      );
      const getAllSettingPenilaianByJenisPelatihanId =
        await settingPenilaianPresenter.getAllSettingPenilaian(
          1,
          1000000,
          '',
          jenis_pelatihan_id
        );

      const data = getAllSettingPenilaianByJenisPelatihanId;

      setState((prevstate) => ({
        ...prevstate,
        settingPeniaian: data,
        formJenisPelatihanId: Number(jenis_pelatihan_id),
      }));

      setLoading(false);

      return data;
    } catch (error: any) {
      console.log('error setting penilaian:', error);
      setLoading(false);
    }
  };

  const actionFormSettingPenilaian = async () => {
    setFormLoading(true);

    if (
      state.formJenisPelatihanId == 0 ||
      state.formNilaiBawah == null ||
      state.formNilaiAtas == null ||
      state.formPredikat == null
    ) {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      return;
    }

    try {
      const settingPenilaianPresenter = container.resolve(
        SettingPenilaianPresenter
      );
      if (state.formDialog == 'Tambah') {
        const action = await settingPenilaianPresenter.storeSettingPenilaian(
          state.formJenisPelatihanId,
          state.formNilaiBawah,
          state.formNilaiAtas,
          state.formPredikat
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogFormSettingPenilaian(false);
          setShowModalSettingPenilaian(true, data.data.data.jenis_pelatihan_id);
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Tambah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      } else if (state.formDialog == 'Ubah') {
        const action = await settingPenilaianPresenter.updateSettingPenilaian(
          state.formId,
          state.formJenisPelatihanId,
          state.formNilaiBawah,
          state.formNilaiAtas,
          state.formPredikat
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialogFormSettingPenilaian(false);
          setShowModalSettingPenilaian(true, data.data.data.jenis_pelatihan_id);
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Ubah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error setting penilaian :', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setUpdateSettingPenilaian = (value: SettingPenilaian) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value.id,
      formJenisPelatihanId: Number(value.jenis_pelatihan_id),
      formNilaiBawah: value.nilai_bawah,
      formNilaiAtas: value.nilai_atas,
      formPredikat: value.predikat,
    }));

    setFormDialog('Ubah');
    setShowDialogFormSettingPenilaian(true);
  };

  const deleteSettingPenilaian = async () => {
    setFormLoading(true);

    try {
      const settingPenilaianPresenter = container.resolve(
        SettingPenilaianPresenter
      );
      const action = await settingPenilaianPresenter.deleteSettingPenilaian(
        state.formId
      );
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success(data.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogDeleteSettingPenilaian(false);
        setShowModalSettingPenilaian(true, state.selectJenisPelatihanId);
        clearForm();
      } else {
        toast.error('Ada Kesalahan Saat Hapus Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);
      console.log('error jenis pelatihan:', error);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setFormId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value,
    }));
  };

  const setShowDialogTolakPengajuan = (
    value: boolean,
    pengajuanJenisPelatihan: PengajuanJenisPelatihan | null
  ) => {
    if (pengajuanJenisPelatihan != null) {
      setState((prevstate) => ({
        ...prevstate,
        formId: pengajuanJenisPelatihan.id,
        formSubMenuJenisPelatihanId:
          pengajuanJenisPelatihan.sub_menu_jenis_pelatihan_id,
        formNamaPelatihan: pengajuanJenisPelatihan.nama_pelatihan,
        formWaktuMulai: pengajuanJenisPelatihan.waktu_mulai,
        formWaktuSelesai: pengajuanJenisPelatihan.waktu_selesai,
        formKompetensi: pengajuanJenisPelatihan.kompetensi,
        formJP: pengajuanJenisPelatihan.jp,
        formKeterangan: pengajuanJenisPelatihan.keterangan,
        showDialogTolakPengajuan: value,
      }));
    } else {
      setState((prevstate) => ({
        ...prevstate,
        showDialogTolakPengajuan: value,
      }));
    }
  };

  const setShowDialogFormTolakPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogFormTolakPengajuan: value,
      showDialogTolakPengajuan: false,
    }));
  };

  const setShowDialogTerimaPengajuan = (
    value: boolean,
    pengajuanJenisPelatihan: PengajuanJenisPelatihan | null
  ) => {
    if (pengajuanJenisPelatihan != null) {
      setState((prevstate) => ({
        ...prevstate,
        formId: pengajuanJenisPelatihan.id,
        formSubMenuJenisPelatihanId:
          pengajuanJenisPelatihan.sub_menu_jenis_pelatihan_id,
        formNamaPelatihan: pengajuanJenisPelatihan.nama_pelatihan,
        formWaktuMulai: pengajuanJenisPelatihan.waktu_mulai,
        formWaktuSelesai: pengajuanJenisPelatihan.waktu_selesai,
        formKompetensi: pengajuanJenisPelatihan.kompetensi,
        formJP: pengajuanJenisPelatihan.jp,
        formKeterangan: pengajuanJenisPelatihan.keterangan,
        showDialogTerimaPengajuan: value,
      }));
    } else {
      setState((prevstate) => ({
        ...prevstate,
        showDialogTerimaPengajuan: value,
      }));
    }
  };

  const setShowDialogFormTerimaPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogFormTerimaPengajuan: value,
      showDialogTerimaPengajuan: false,
    }));
  };

  const actionDialogFormTolakPengajuan = async () => {
    setFormLoading(true);

    if (
      (state.formSubMenuJenisPelatihanId == 0 ||
        state.formNamaPelatihan == '' ||
        state.formKompetensi == '' ||
        state.formWaktuMulai == '' ||
        state.formWaktuSelesai == '' ||
        state.formJP == '' ||
        state.formKeterangan == '',
      state.formAlasan == '')
    ) {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setFormLoading(false);
      return;
    }

    try {
      const pengajuanJenisPelatihanPresenter = container.resolve(
        PengajuanJenisPelatihanPresenter
      );
      const dateWaktuMulai = new Date(state.formWaktuMulai);
      const formattedWaktuMulai = dateWaktuMulai
        .toISOString()
        .replace('T', ' ')
        .split('.')[0];

      const dateWaktuSelesai = new Date(state.formWaktuSelesai);
      const formattedWaktuSelesai = dateWaktuSelesai
        .toISOString()
        .replace('T', ' ')
        .split('.')[0];

      const action =
        await pengajuanJenisPelatihanPresenter.updatePengajuanJenisPelatihan(
          state.formId,
          state.formSubMenuJenisPelatihanId,
          state.formNamaPelatihan,
          formattedWaktuMulai,
          formattedWaktuSelesai,
          state.formKompetensi,
          state.formJP,
          state.formKeterangan,
          'ditolak',
          '',
          state.formAlasan
        );
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success('Berhasil Menolak Jenis Pelatihan Yang Diajukan', {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogFormTolakPengajuan(false);
        getPengajuanJenisPelatihan(
          state.pagePengajuan,
          state.keywordPengajuan,
          state.rowPengajuan,
          state.subMenuJenisPelatihanIdActive,
          state.filterStatusPengajuan
        );
        clearForm();
      } else {
        toast.error('Ada Kesalahan Saat Tambah Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const actionDialogFormTerimaPengajuan = async () => {
    setFormLoading(true);

    if (
      (state.formSubMenuJenisPelatihanId == 0 ||
        state.formNamaPelatihan == '' ||
        state.formKompetensi == '' ||
        state.formWaktuMulai == '' ||
        state.formWaktuSelesai == '' ||
        state.formJP == '' ||
        state.formKeterangan == '',
      state.formKode == '')
    ) {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setFormLoading(false);
      return;
    }

    try {
      const pengajuanJenisPelatihanPresenter = container.resolve(
        PengajuanJenisPelatihanPresenter
      );
      const dateWaktuMulai = new Date(state.formWaktuMulai);
      const formattedWaktuMulai = dateWaktuMulai
        .toISOString()
        .replace('T', ' ')
        .split('.')[0];

      const dateWaktuSelesai = new Date(state.formWaktuSelesai);
      const formattedWaktuSelesai = dateWaktuSelesai
        .toISOString()
        .replace('T', ' ')
        .split('.')[0];

      const action =
        await pengajuanJenisPelatihanPresenter.updatePengajuanJenisPelatihan(
          state.formId,
          state.formSubMenuJenisPelatihanId,
          state.formNamaPelatihan,
          formattedWaktuMulai,
          formattedWaktuSelesai,
          state.formKompetensi,
          state.formJP,
          state.formKeterangan,
          'diterima',
          state.formKode,
          ''
        );
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success('Berhasil Menerima Jenis Pelatihan yang diajukan', {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogFormTerimaPengajuan(false);
        getPengajuanJenisPelatihan(
          state.pagePengajuan,
          state.keywordPengajuan,
          state.rowPengajuan,
          state.subMenuJenisPelatihanIdActive,
          state.filterStatusPengajuan
        );
        clearForm();
      } else {
        toast.error('Ada Kesalahan Saat Tambah Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  return (
    <MasterJenisPelatihanProvider
      value={{
        state,
        getMenuJenisPelatihan,
        getSubMenuJenisPelatihan,
        setPage,
        setPagePengajuan,
        setPageRow,
        setPageRowPengajuan,
        setFormDialog,
        setUpdate,
        actionFormDialog,
        setFormMenuJenisPelatihan,
        setFormMenuJenisPelatihanId,
        setFormSubMenuJenisPelatihan,
        setFormSubMenuJenisPelatihanId,
        setFormKode,
        setFormNamaPelatihan,
        setFormWaktuMulai,
        setFormWaktuSelesai,
        setFormKompetensi,
        setFormJP,
        setFormKeterangan,
        setFormStatusPengajuan,
        setTypeMenu,
        setShowDialog,
        deleteMenuJenisPelatihan,
        setShowDialogDelete,
        getJenisPelatihan,
        getPengajuanJenisPelatihan,
        setShowDialogJenisPelatihan,
        setShowDialogPengajuanJenisPelatihan,
        setShowDialogDeleteJenisPelatihan,
        setShowDialogDeletePengajuanJenisPelatihan,
        searchJenisPelatihan,
        searchPengajuanJenisPelatihan,
        actionFormDialogJenisPelatihan,
        actionFormDialogPengajuanJenisPelatihan,
        setUpdateJenisPelatihan,
        setUpdatePengajuanJenisPelatihan,
        deleteJenisPelatihan,
        deletePengajuanJenisPelatihan,
        clearForm,
        setActiveMenu,
        setShowModalSettingPenilaian,
        setShowDialogFormSettingPenilaian,
        setShowDialogDeleteSettingPenilaian,
        setFormJenisPelatihanId,
        setFormNilaiBawah,
        setFormNilaiAtas,
        setFormPredikat,
        getSettingPenilaian,
        actionFormSettingPenilaian,
        setUpdateSettingPenilaian,
        deleteSettingPenilaian,
        setFormId,
        setMetodePenambahan,
        setFilterStatusPengajuan,
        setShowDialogTolakPengajuan,
        setShowDialogFormTolakPengajuan,
        setShowDialogTerimaPengajuan,
        setShowDialogFormTerimaPengajuan,
        setFormAlasan,
        actionDialogFormTolakPengajuan,
        actionDialogFormTerimaPengajuan,
      }}
    >
      {children}
    </MasterJenisPelatihanProvider>
  );
};

export const useMasterJenisPelatihanContext = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useMasterJenisPelatihanContext,
  Provider,
};
